export default __webpack_public_path__ + "static/media/C7ZTQ.0e4ff3e6.jpg";